import type { SearchResultFacets } from '../../utils'

import { useSignal } from '@preact/signals-react'
import { useSignals } from '@preact/signals-react/runtime'
import clx from 'classnames'
import * as $ from '../../signal/searchbox'
import { StarsIcon } from '../Icons/Icons'
import styles from './Facets.module.css'

export const Facets = ({
  facets,
  className
}: {
  facets?: SearchResultFacets
  className?: string
}) => {
  useSignals()
  const currentFacet = useSignal($.currentFacet).value
  const facetsList = facets || useSignal($.facets).value.value
  const theme = useSignal($.theme).value

  const primaryTheme = theme.value === 'primary'

  const listClass = [styles.searchbox__result__facet__list, className].join(' ')

  const summaryAiBtn = (
    <button
      type="button"
      onClick={() => {
        $.isSummaryExpanded.value = true
        $.currentFacet.value = ''
      }}
      className={clx(styles.searchbox__result__summaryBtn, {
        [styles.searchbox__result__summaryBtn__active]: $.isSummaryExpanded.value === true
      })}
    >
      <StarsIcon />
      AI Summary
    </button>
  )

  if (!facetsList || Object.keys(facetsList).length <= 1) {
    return (
      <ul className={[listClass, styles.searchbox__result__facet__list__single].join(' ')}>
        {primaryTheme && <li>{summaryAiBtn}</li>}
        <li>
          <button
            type="button"
            className={`${styles.searchbox__result__facet} ${
              currentFacet.value === Object.keys(facetsList)[0] && styles.searchbox__result__facet__active
            } ${styles.searchbox__result__facet__singleFacet}`}
            onClick={() => {
              $.currentFacet.value = Object.keys(facetsList)[0]
              if ($.isSummaryExpanded.value) {
                $.isSummaryExpanded.value = false
              }
            }}
          >
            Search results{' '}
            <span className={styles.searchbox__result__facet__number}>{facetsList[Object.keys(facetsList)[0]]}</span>
          </button>
        </li>
      </ul>
    )
  }

  return Object.keys(facetsList).length > 1 ? (
    <ul className={listClass}>
      {primaryTheme && <li>{summaryAiBtn}</li>}
      {Object.keys(facetsList).map((facetName, i) => {
        if (!facetsList[facetName] || !facetName) return null
        return (
          <li
            key={`${facetName}-${
              // biome-ignore lint/suspicious/noArrayIndexKey: i is fine here
              i
            }`}
          >
            <button
              type="button"
              className={`${styles.searchbox__result__facet} ${
                currentFacet.value === facetName && styles.searchbox__result__facet__active
              }`}
              onClick={() => {
                $.currentFacet.value = facetName
                if ($.isSummaryExpanded.value) {
                  $.isSummaryExpanded.value = false
                }
              }}
            >
              {facetName} <span className={styles.searchbox__result__facet__number}>{facetsList[facetName]}</span>
            </button>
          </li>
        )
      })}
    </ul>
  ) : null
}
